import PageTitle from "../../components/PageTitle";
import Tx from "../../components/Tx";
import IconBtn from "../../components/IconBtn";
import { useEffect, useState } from "react";
import InstallerDialog from '../../components/InstallerDialog';
import { api } from "../../maps/data.js";
import Table from '../../components/Table';
import InstallerAddUsersDialog from '../../components/dialogs/InstallerAddUsersDialog';
import Icn from '../../components/Icn';
import InstallerSensorsDialog from '../../components/dialogs/InstallerSensorsDialog';
import InstallerEdgesDialog from '../../components/dialogs/InstallerEdgesDialog';

export default function InstallersPage() {
    const [opend, s_opend] = useState(false);
    const [open_sensors, s_open_sensors] = useState(false);
    const [open_sensors_installer_obj, s_open_sensors_installer_obj] = useState(false);
    const [open_edges, s_open_edges] = useState(false);
    const [open_edges_installer_obj, s_open_edges_installer_obj] = useState(false);
    const [open_installer_user_d, s_open_installer_user_d] = useState(false);
    const [installers, s_installers] = useState([]);
    const [installer_obj_for_add, s_installer_obj_for_add] = useState();

    const get = async () => {
        const installers_res = await api({
            type: 'getInstallers',
            data: {
                withUsers: true
            }
        });
        s_installers(installers_res.map(d => ({ ...d, collapseData: d.users && d.users.map(u => ({ ...u, role: <Tx>{`user.add.${u.role}`}</Tx> })) })));
    }

    useEffect(() => {
        get();
    }, []);

    return (
        <div style={{ height:'100%', overflowY:'scroll', padding: 20 }}>
            <PageTitle>
                <Icn>installer</Icn> <Tx>page.installers.title</Tx>
                <IconBtn
                    style={{ position: 'absolute', right: 20 }}
                    onClick={() => s_opend({})}
                >
                    add
                </IconBtn>
            </PageTitle>
            <Table
                collapse={true}
                collapseComponent={Table}
                collapseProps={{
                    headers: [
                        { label: <Tx>user.table.name</Tx>, field: 'name' },
                        { label: <Tx>user.table.email</Tx>, field: 'email' },
                        { label: <Tx>user.table.role</Tx>, field: 'role' },
                    ]
                }}
                collapseStyle={{ margin: '20px 0', background: '#eee' }}
                collapseChildren="edit"
                data={installers}
                headers={[
                    { label: <Tx>user.installer.name</Tx>, field: 'name' },
                ]}
                actions={[
                    {
                        icon: 'addPerson',
                        action: item => {
                            s_open_installer_user_d(true);
                            s_installer_obj_for_add(item);
                        }
                    },
                    {
                        icon: 'edit',
                        action: item => s_opend(item)
                    },
                    {
                        icon: 'sensor',
                        action: (row) => {
                            s_open_sensors_installer_obj(row);
                            s_open_sensors(true);
                        }
                    },
                    {
                        icon: 'edge',
                        action: (row) => {
                            s_open_edges_installer_obj(row);
                            s_open_edges(true);
                        }
                    },

                ]}
            />
            {
                opend && <InstallerDialog open={opend} onClose={() => { get(); s_opend(false) }} />
            }
            {
                open_sensors && <InstallerSensorsDialog installer={open_sensors_installer_obj} open={open_sensors} onClose={() => {s_open_sensors(false)}} />
            }
            {
                open_edges && <InstallerEdgesDialog installer={open_edges_installer_obj} open={open_edges} onClose={() => {s_open_edges(false)}} />
            }
            {
                open_installer_user_d && <InstallerAddUsersDialog
                    installer={installer_obj_for_add}
                    open={open_installer_user_d}
                    onClose={() => { get(); s_open_installer_user_d(false) }}
                />
            }
        </div>
    )
}